const STORAGE_KEY = 'bhima-store.pos-counter';

const COUNTER_PATTERN = /^[A-Z0-9]{1,16}$/;

export function isValidPosCounter(value) {
  return COUNTER_PATTERN.test(String(value || '').trim().toUpperCase());
}

/** Counter chosen for this cashier — survives refresh, cleared on sign-out. */
export function loadPosCounter(sub) {
  if (!sub) return '';
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    if (parsed?.sub !== sub || typeof parsed.counter !== 'string') return '';
    const counter = parsed.counter.trim().toUpperCase();
    return isValidPosCounter(counter) ? counter : '';
  } catch {
    return '';
  }
}

export function savePosCounter(sub, counter) {
  if (!sub) return;
  const normalized = String(counter || '').trim().toUpperCase();
  if (!isValidPosCounter(normalized)) return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ sub, counter: normalized }));
  } catch {
    // Private mode / quota — session still works without persistence.
  }
}

export function clearPosCounter() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clear.
  }
}
